export default __webpack_public_path__ + "static/media/atom.23561d6a.svg";